var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "site-logo",
      class: { "site-logo--text": !_vm.logoSrc },
      style: _vm.rootStyle,
      attrs: { href: _vm.href, "aria-label": _vm.name },
    },
    [
      _vm.logoSrc
        ? _c(
            "img",
            _vm._b(
              {
                staticClass: "site-logo__img",
                style: _vm.imgStyle,
                attrs: { alt: _vm.name },
              },
              "img",
              _vm.logoAttrs,
              false
            )
          )
        : _c("span", { staticClass: "site-logo__name", style: _vm.nameStyle }, [
            _vm._v(_vm._s(_vm.name)),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }